import Button from "app/components/Button";
import MultiSelect from "app/components/MultiSelect";
import SingleSelect from "app/components/SingleSelect";
import React from "react";
import LoaderOverlay from "../../Team/components/LoaderOverlay";

export const StageRenderer = ({ stage, loading, handleCreateTeam, isTeamCreated ,isDisabled}) => {
  switch (stage.type) {
    case "single-select":
      return loading ? (
       <LoaderOverlay />
      ) : (
        <SingleSelect
          options={stage.options}
          selected={stage.value}
          onChange={stage.onChange}
          className={stage.className}
        />
      );

    case "multi-select":
      return (
        <MultiSelect
          options={stage.options}
          selected={stage.value}
          onChange={stage.onChange}
          className={stage.className}
        />
      );

    case "button":
      return (
        <Button
          onClick={handleCreateTeam}
          isLoading={isTeamCreated}
          disabled={isDisabled}
          className="w-[390px] h-[56px]"
          disabledClassName="bg-secondary"
        >
          Create team
        </Button>
      );

    default:
      return null;
  }
};
